module.exports = __webpack_public_path__ + "about.png?4c5e2d7222116bec79ad29e75a0f8a07";


//////////////////
// WEBPACK FOOTER
// ./src/assets/photos/about.png
// module id = 176
// module chunks = 0